import {
  FiLayers,
  FiArchive,
  FiTruck,
  FiFileText,
  FiUsers,
  FiClipboard,
  FiBriefcase,
  FiShoppingCart,
} from "react-icons/fi";
import { FaRupeeSign } from "react-icons/fa";

export const features = [
  {
    key: "project360",
    title: "Project 360",
    icon: FiLayers,
    tagline:
      "Project setup, cost control, and full cycle visibility with dashboards and procurement governance.",
    bullets: [
      "Seamless project setup with standardized structures and configurations.",
      "Build and manage Project BOQs for cost planning and control.",
      "Procurement governance and control across all stages.",
      "Interactive dashboards and real time reports for end to end visibility.",
    ],
  },
  {
    key: "marketplace",
    title: "Marketplace",
    icon: FiShoppingCart,
    tagline:
      "Material requisition management with digital indents, unified approvals, and auditability.",
    bullets: [
      "Quick, digital indent creation from site or mobile.",
      "Track approvals and clarifications in a unified workflow.",
      "Transparency and accountability at every stage.",
      "Automated tracking reduces manual dependency.",
    ],
  },
  {
    key: "conversion",
    title: "Conversion Workbench",
    icon: FiClipboard,
    tagline:
      "Connect indents to execution: issues, transfers, or POs with budget checks and forecast controls.",
    bullets: [
      "Instantly convert indents into project issues, warehouse transfers, or purchase requisitions.",
      "Maintain cost accuracy with budget validations and forecast controls.",
      "Improve visibility on material flow, usage, and allocation.",
      "Automated, traceable workflows minimize errors.",
    ],
  },
  {
    key: "procure360",
    title: "Procure 360",
    icon: FiBriefcase,
    tagline:
      "End to end digital procurement from RFQs to POs with ERP sync and faster approvals.",
    bullets: [
      "Manage RFQs, vendor evaluations, and PO finalizations on one platform.",
      "ERP integration for data accuracy.",
      "Faster approval cycles with e workflows and notifications.",
      "Transparent, paperless transactions strengthen vendor relationships.",
    ],
  },

  {
    key: "vendorPortal",
    title: "Vendor Portal (Onboarding)",
    icon: FiUsers,
    tagline: "Fast, compliant vendor onboarding with docs and approvals.",
    bullets: [
      "Self service registration with guided steps.",
      "Document collection with validations.",
      "Approval workflows with status transparency for vendors.",
      "Centralized repository for vendor master data.",
    ],
  },
  {
    key: "warehouseMobility",
    title: "Warehouse Mobility",
    icon: FiArchive,
    tagline:
      "Digitized inbound, outbound, transfers, and returns with real time inventory and exception handling.",
    bullets: [
      "Record inwards, issues, transfers, and returns via mobile or tablet.",
      "Live visibility of stock levels and locations.",
      "Exception handling with alerts and validations.",
      "Replace manual registers with intelligent, paperless workflows.",
    ],
  },
  {
    key: "gateSecurePass",
    title: "Gate & SecurePass",
    icon: FiTruck,
    tagline:
      "Secure control of material and vehicle movements with QR scanning, geotagging, and digital records.",
    bullets: [
      "Generate and approve inward and outward gatepasses digitally.",
      "Use QR scanning for instant check ins and check outs.",
      "Capture vehicle images, load proofs, and empty status digitally.",
      "Integrated documentation and verification to prevent unauthorized entries.",
      "Maintain complete digital audit trails for compliance and reporting.",
    ],
  },
  {
    key: "payments",
    title: "Digital Tracking System (Payments)",
    icon: FaRupeeSign,
    tagline:
      "Create a single track for payments across projects and vendors with real time status and accountability.",
    bullets: [
      "Track invoices from submission to approval with clear ownership.",
      "See payment status and pending actions in one place.",
      "Automated alerts reduce follow ups across teams.",
      "Dashboards give finance and projects shared visibility.",
    ],
  },
  {
    key: "paperless",
    title: "Digital Transformation Paperless Office",
    icon: FiFileText,
    tagline:
      "Digitize records and workflows for a secure, cloud based, sustainable office and establish a digital library.",
    bullets: [
      "Digitize existing and historical records into a centralized library.",
      "Streamline approvals, documentation, and financial transactions.",
      "Reduce paper dependency; boost sustainability across departments.",
      "Secure, cloud based record management for organizational efficiency.",
    ],
  },
];
